import { Classes } from '../ui/popover'
import classNames, { Value as ClassValue } from 'classnames'
import React, { ReactNode } from 'react'
import { OptimizedPopover } from '../App'

interface CalculationProps {
    children: ReactNode
    lines: CalculationLine[]
}

export interface CalculationLine {
    description: string
    value: string
}

export const Calculation = ({ children, lines }: CalculationProps) => {
    const content = (
        <div className="text-xs">
            {lines
                .filter((_, i) => i < lines.length - 1)
                .map((line, i) => {
                    return <Line key={i} {...line} />
                })}
            <Line
                className="border-t mt-1 pt-1 font-medium"
                description={lines[lines.length - 1].description}
                value={lines[lines.length - 1].value}
            />
        </div>
    )

    return (
        <OptimizedPopover
            popoverClassName={Classes.POPOVER2_CONTENT_SIZING + ' calculation'}
            content={content}
            interactionKind="hover"
            position="bottom"
        >
            {children}
        </OptimizedPopover>
    )
}

interface LineProps extends CalculationLine {
    className?: ClassValue
}

const Line = ({ description, value, className }: LineProps) => {
    return (
        <div className={classNames('flex items-center justify-between', className)}>
            <div className="mr-4">{description}</div>
            <div className="font-mono">{value}</div>
        </div>
    )
}
